import _ from "underscore";
import $ from "jquery";
import CampaignModel from "src/shared/campaigns/CampaignModel";
import CampaignCollection from "src/shared/campaigns/CampaignCollection";
import CampaignSummaryCollection from "src/shared/campaigns/CampaignSummaryCollection";
import CampaignSummaryModel from "src/shared/campaigns/CampaignSummaryModel";
import BuiltCampaignModel from "./BuiltCampaignModel";
import BuiltCampaignCollection from "./BuiltCampaignCollection";

function loadCampaignSummaries() {
    const deferred = $.Deferred();
    const campaignSummaries = new CampaignSummaryCollection();
    $.when(campaignSummaries.fetch())
        .done(() => {
            deferred.resolve(campaignSummaries);
        })
        .fail(deferred.reject);
    return deferred;
}

function loadCampaignSummariesByProgramLabel(filterModel) {
    const deferred = $.Deferred();
    const campaigns = CampaignSummaryCollection.create(filterModel);
    $.when(campaigns.getCampaignSummariesbyProgramLable())
        .done(() => {
            deferred.resolve(campaigns);
        })
        .fail(deferred.reject);
    return deferred;
}

function loadProgramLabels() {
    return loadCampaignSummaries().then((collection) =>
        _.groupBy(collection.toJSON(), "program_label")
    );
}

function loadCampaignSummary(campaignId) {
    const deferred = $.Deferred();
    const campaign = CampaignSummaryModel.create(campaignId);
    $.when(campaign.fetch())
        .done(() => {
            deferred.resolve(campaign);
        })
        .fail(deferred.reject);
    return deferred;
}

function loadCampaign(campaignId) {
    const deferred = $.Deferred();
    const campaign = CampaignModel.create(campaignId);
    $.when(campaign.fetch())
        .done(() => {
            deferred.resolve(campaign);
        })
        .fail(deferred.reject);
    return deferred;
}

function loadCampaigns() {
    const deferred = $.Deferred();
    const campaigns = CampaignCollection.create();
    $.when(campaigns.fetch())
        .done(() => {
            deferred.resolve(campaigns);
        })
        .fail(deferred.reject);
    return deferred;
}

function loadBuiltCampaign(campaignId) {
    const deferred = $.Deferred();
    const campaign = BuiltCampaignModel.create(campaignId);
    $.when(campaign.fetch())
        .done(() => {
            deferred.resolve(campaign);
        })
        .fail(deferred.reject);
    return deferred;
}

function loadBuiltCampaigns() {
    const deferred = $.Deferred();
    const campaigns = BuiltCampaignCollection.create();
    $.when(campaigns.fetch())
        .done(() => {
            deferred.resolve(campaigns);
        })
        .fail(deferred.reject);
    return deferred;
}

export default {
    loadCampaignSummary,
    loadCampaignSummaries,
    loadProgramLabels,
    loadCampaign,
    loadCampaigns,
    loadBuiltCampaign,
    loadBuiltCampaigns,
    loadCampaignSummariesByProgramLabel,
};
